import React, { useEffect, useState } from "react";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../../firebase";
import { useAuth } from "../../contexts/AuthContext";

const PrivacySettings = () => {
  const { currentUser } = useAuth();
  const [visibility, setVisibility] = useState("public");
  const [message, setMessage] = useState("");

  useEffect(() => {
    const fetchVisibility = async () => {
      if (!currentUser) return;
      const ref = doc(db, "users", currentUser.uid);
      const snap = await getDoc(ref);
      if (snap.exists()) {
        const data = snap.data();
        if (data.visibility) setVisibility(data.visibility);
      }
    };
    fetchVisibility();
  }, [currentUser]);

  const handleToggle = async () => {
    if (!currentUser) return;
    const newVisibility = visibility === "public" ? "private" : "public";
    try {
      await updateDoc(doc(db, "users", currentUser.uid), {
        visibility: newVisibility,
      });
      setVisibility(newVisibility);
      setMessage(`✅ Profile visibility set to "${newVisibility}"`);
    } catch (err) {
      console.error("Visibility update error:", err);
      setMessage("❌ Failed to update visibility.");
    }
  };

  return (
    <div className="space-y-4 text-sm">
      <h2 className="text-lg font-semibold mb-2">Privacy Settings</h2>

      <div className="bg-gray-100 p-4 rounded shadow-sm flex justify-between items-center">
        <div>
          <h3 className="font-medium">Profile Visibility</h3>
          <p className="text-gray-600 text-xs">
            Your profile is currently <strong>{visibility}</strong>.
            Toggle to change how others see your profile.
          </p>
        </div>
        <input
          type="checkbox"
          checked={visibility === "public"}
          onChange={handleToggle}
          className="form-checkbox h-5 w-5"
        />
      </div>

      {message && (
        <p className={`text-xs ${message.startsWith("✅") ? "text-green-600" : "text-red-600"}`}>
          {message}
        </p>
      )}
    </div>
  );
};

export default PrivacySettings;
